export const PROJECTS = {
    levent: 'Levent',
    gokturk: 'Göktürk'
};

export const getProject = () => {
    const value = new URLSearchParams(window.location.search).get('project');
    return value && PROJECTS[value] ? value : 'levent';
};

export const getProjectLabel = (project = getProject()) => PROJECTS[project];

export const withProject = (path, project = getProject()) => {
    if (project === 'levent') return path;
    return `${path}${path.includes('?') ? '&' : '?'}project=${project}`;
};
